import { Alert } from '@/common/components'
import useI18n from '@/shared/hooks/usei18n'

export function SupplierEmissionsReportLinkedGoodsCallout() {
  const { t } = useI18n()

  return (
    <Alert type="info" className="mb-6">
      {t('supplierEmissionsReport:linkedImportedGoodsCallout')}
    </Alert>
  )
}
